import { revisionPartVOs } from "./revision-part-vo.model";
export interface RevisionHistory {
    id: number;
    country: string;
    createDate: any;
    dealerName: string;
    dealerAddress: string;
    dealerCode: number;
    kilometers: number;
    revisionCode: number;
    revisionDate: string;
    formattedRevisionDate: string;
    revisionName: string;
    serviceOrder: number;
    user: string;
    vin: string;
    months: number;
    parts: revisionPartVOs[];
}
